import waitingRoomReducer from "./WaitingRoom/waitingRoomReducer";
import videoRoomReducer from "./VideoRoom/videoRoomReducer";
import participantsListReducer from "./ParticipantsList/participantsListReducer";
import { combineReducers } from "redux";

export default combineReducers({
    waitingRoomReducer,
    videoRoomReducer,
    participantsListReducer
})
